export default "__VITE_ASSET__27zjGA1I__"